import { Component, Injector, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { RiderService } from '../../../../core/services/rider.service';
import { Subscription } from 'rxjs/Subscription';
import { IvrStatusEnum } from 'app/core/enums/reminders.enum';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';
declare var jQuery: any;

@Component({
  selector: 'app-rider-ivr-information',
  templateUrl: './rider-ivr-information.component.html',
  styleUrls: ['./rider-ivr-information.component.scss']
})
export class RiderIvrInformationComponent extends ParentModule implements OnInit, OnDestroy {
  public activeIVRTab = 0;

  @Input() formIvr: FormGroup;
  riderLanguages: any = [];
  private subscriptions: Subscription[] = [];
  private firstOpt = false;
  private numChanges = 0;
  public ivrStatusOptions = [
    {value: IvrStatusEnum.NONE, label: 'None'},
    {value: IvrStatusEnum.OPT_IN, label: 'Opt-in'},
    {value: IvrStatusEnum.OPT_OUT, label: 'Opt-out'},
  ];

  constructor(
    private _riderService: RiderService,
    private sweetAlertHelper: SweetAlertHelper,
    private _loadingT2: T2LoadingService,
    protected Inject: Injector,
  ) {
    super('app-rider-form', Inject);
  }

  ngOnInit() {
    this.listenControlIvr();
    this.getLanguagesRider();
  }

  /**
   * @name listenControlIvr
   * @description escucha el cambio en el control para activar el tab
   * */
  listenControlIvr(): void {
    this.subscriptions.push(
      this.formIvr.controls['ivrstatus'].valueChanges.subscribe((val) => {
        if (val || val === IvrStatusEnum.NONE) {
          if (this.numChanges === 0) {
            this.firstOpt = val !== IvrStatusEnum.NONE;
            this.numChanges++;
          }
          if (this.activeIVRTab !== val) {
            this.activeIVRTab = val;
          }
        }
      })
    );
  }

  onSendMailChange(event: Event): void {
    if (!this.isAllowedAction('SendVerifyEmail')) { return; };

    const riderId =  this.getControlByFormIvr('riderid').value;
    if (!riderId) { return; }

    const { checked } = event.target as HTMLInputElement;
    if (!checked) { return; }

    const emailWasVerified = this.getControlByFormIvr('emailverified').value;
    if (emailWasVerified) { return; }

    const email = this.getControlByFormIvr('email').value;
    const emailIsValid = this.getControlByFormIvr('email').valid;

    if (!email || !emailIsValid) {
      this.sweetAlertHelper
        .throwErrorAlert('Please verify the email')
        .then(() => this.getControlByFormIvr('sendmail').setValue(false));

      return;
    }

    this.sweetAlertHelper.createCustomAlert({
      title: 'Confirm Email',
      text: 'A confirmation email will be sent to verify this email address',
      confirmButtonText: 'Continue',
      cancelButtonText: 'Cancel',
      showCancelButton: true,
    }).then((result) => {
      const { dismiss } = result;

      if (dismiss) {
        this.getControlByFormIvr('sendmail').setValue(false);
        return;
      }

      this.sendVerifyRiderMail(riderId);
    });
  }

  private sendVerifyRiderMail(riderId: number) {
    this._loadingT2.show('Sending email, please wait...');
    this.subscriptions.push(
      this._riderService
        .sendVerifyEmail(riderId)
        .finally(() => this._loadingT2.hiden())
        .subscribe({
          next: ({ message }) =>
            this.sweetAlertHelper.createCustomAlert({
              title: 'Success',
              type: 'success',
              text: message,
            }),
          error: (err) => this.sweetAlertHelper.captureException(err),
        }),
    );
  }

  /**
   * @name onClickMenuIvr
   * @description pasa el Value
   * */
  onClickMenuIvr(value: number): void {
    this.changeValuesIvrAndTab(Number(value));
    // this.changeClassAnimate(value);
  }

  /**
   * @name changeClassAnimate
   * @description modifica las clasess
   * */
  changeClassAnimate(num: number): void {
    let left = 0;
    let classChange = '';
    if (num === IvrStatusEnum.NONE) {classChange = 'optNull'; left = 50; }
    if (num === IvrStatusEnum.OPT_IN) {classChange = 'optIn'; left = 0; }
    if (num === IvrStatusEnum.OPT_OUT) {classChange = 'optOut'; left = 100; }
    jQuery('.switch').removeClass('optIn');
    jQuery('.switch').removeClass('optNull');
    jQuery('.switch').removeClass('optOut');
    jQuery('.switch').addClass(classChange);
    jQuery('.switch').stop().animate({left: left}, 300);
  }

  /**
   * @name changeValuesIvrAndTab
   * @description realiza los cambios en form si cambia de status
   * @param num
   * */
  changeValuesIvrAndTab(num: number): void {
    if (num !== this.activeIVRTab) {
      this.formIvr.patchValue({
        sendsms: false,
        sendmail: false,
        makephonecall: false,
        virtualagent: false,
        preferredlanguage: null,
      });
    }
  }

  /**
   * @name onChangeCheck
   * @description
   * */
  onChangeCheck(): boolean {
    const ivrStatus = this.formIvr.get('ivrstatus').value;

    if (ivrStatus === IvrStatusEnum.OPT_OUT || ivrStatus === IvrStatusEnum.NONE) {
      return false;
    }

    return !this.hasAnyMethodSelected;
  }

  get hasAnyMethodSelected(): boolean {
    const controls = ['sendmail', 'sendsms', 'virtualagent', 'makephonecall'];
    return controls.some(control => this.formIvr.get(control).value);
  }

  get isInactive(): boolean {
    return this.formIvr.get("isinactive").value;
  }

  getLanguagesRider() {
    this.subscriptions.push(
      this._riderService.getRiderLanguage().subscribe({
        next: (resp: any) => {
          this.riderLanguages = resp;
        },
        error: (err) => {
          this.sweetAlertHelper.captureException(err.message);
        },
      })
    );
  }

  noneOptionNotAllowed(option: number): boolean {
    return this.firstOpt && option === IvrStatusEnum.NONE;
  }

  get hideReminderOptions(): boolean {
    const optionsNotAllowed = [IvrStatusEnum.NONE, IvrStatusEnum.OPT_OUT];
    return !optionsNotAllowed.includes(this.activeIVRTab);
  }

  validateIvrAndVirtualAgent(control: string, check: boolean): void {
    const ivrStatus = this.formIvr.get('ivrstatus').value;

    if (ivrStatus !== IvrStatusEnum.OPT_IN) {
      return;
    }

    this.formIvr.get('makephonecall').setValue(false);
    this.formIvr.get('virtualagent').setValue(false);
    this.formIvr.get(control).setValue(check);
  }

  private getControlByFormIvr(controlName: string): AbstractControl {
    return this.formIvr.get(controlName);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/rider/components/rider-ivr-information/rider-ivr-information.component.ts